import React, { Component } from "react";
import { NavLink, Link, Switch, Route } from "react-router-dom";
import Creche from "./Creche";
import InfoCreche from "./InfoCreche";
import StaffCreche from "./StaffCreche";
import ArchiveEnfants from "./ArchiveEnfants";
import SectionsCreche from "./SectionsCreche";
import { connect } from "react-redux";
import { getInfosCreche } from "./infoCreche.ducks";
import { getFermetures } from "./planningCreche.ducks";
import _ from "lodash";
import { withTranslation } from 'react-i18next';
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import FicheEnfant from "../fiche-enfant/FicheEnfant";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class GestionCreche extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nomCreche: "",
      adresse: "",
      codePostal: "",
      numAgents: "",
      numEnfants: "",
      firstTime: true,
      dataCreche: {},
    };
  }
  componentDidMount() {
    this.props.getInfosCreche(localStorage.getItem("token"));
    this.props.getFermetures(localStorage.getItem("token"));
  }
  componentDidUpdate(prevProps) {
    if (prevProps.dataCreche !== this.props.dataCreche) {
      let { ville, codePostal } = !_.isEmpty(
        this.props.dataCreche.adresseCreche
      )
        ? this.props.dataCreche.adresseCreche
        : { ville: null, codePostal: null };
      this.setState({
        nomCreche: this.props.dataCreche.nom,
        adresse: ville,
        codePostal: codePostal,
        numAgents: this.props.dataCreche.nbAgents,
        numEnfants: this.props.dataCreche.nbEnfants,
        dataCreche: this.props.dataCreche,
      });
    }
    if (prevProps.dataPlanningCreche !== this.props.dataPlanningCreche) {
      this.setState({
        dataPlanningCreche: this.props.dataPlanningCreche,
      });
    }
  }

  render() {
    const { t } = this.props;
    let {
      match: { url },
    } = this.props;
    {
      return (
        <div className="main-wrapper fiche-enfant gestion-creche">
          <div className="banner p-0 d-flex align-items-center justify-content-center">
            <Link to="/" className="back-link">
              {t('common.back')}
            </Link>
            <div className="content">
              <div className="selected-child text-center">
                <h1 className="pt-2">
                  {this.state.nomCreche}
                  <small>
                    à {this.state.adresse} ({this.state.codePostal})
                  </small>
                  <small>
                    {this.state.numAgents} {t('gestion_creche.agents')} | {this.state.numEnfants}{" "}
                    {t('gestion_creche.children')}
                  </small>
                </h1>
              </div>
            </div>
          </div>
          <section className="content-fiche">
            <ul
              className="nav nav-tabs choices-elts d-flex align-items-center justify-content-between"
              id="myTab"
              role="tablist"
            >
              <li className="nav-item">
                <NavLink
                  activeClassName="nav-link choice infos-creche active"
                  to={url + "/infos"}
                  className="nav-link choice infos-creche"
                  id="infos-creche-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  <span>{t('gestion_creche.infos')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="nav-link choice staff active"
                  to={url + `/staff`}
                  className="nav-link choice staff"
                  id="staff-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                >
                  <span>{t('gestion_creche.staff')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="nav-link choice fiche-child active"
                  to={url + `/nouvel_enfant`}
                  className="nav-link choice fiche-child"
                  id="fiche-child-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  <span>{t('gestion_creche.new_kid')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="nav-link choice sections active"
                  to={url + `/sections`}
                  className="nav-link choice sections"
                  id="sections-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="sections"
                  aria-selected="false"
                >
                  <span>{t('gestion_creche.sections')}</span>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  activeClassName="nav-link choice archives-enfants active"
                  to={url + `/archives`}
                  className="nav-link choice archives-enfants"
                  id="archives-enfants-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  <span>{t('gestion_creche.archives')}</span>
                </NavLink>
              </li>
            </ul>
            <Switch>
              <Route
                exact
                path={url + "/infos"}
                component={InfoCreche}
                dataCreche={this.state.dataCreche}
                dataPlanningCreche={this.state.dataPlanningCreche}
              />
              <Route path={url + "/sections"} component={SectionsCreche} />
              <Route path={url + "/staff"} component={StaffCreche} />
              <Route path={url + "/nouvel_enfant"} component={Creche} />
              <Route path={url + "/archives/:id"} component={FicheEnfant} />
              <Route path={url + "/archives"} component={ArchiveEnfants} />
            </Switch>
          </section>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  dataCreche: state.gestionCreche.infos.data,
  loadingInfos: state.gestionCreche.infos.loading,
});
export default connect(mapStateToProps, { getInfosCreche, getFermetures })(
  withTranslation()(GestionCreche)
);
